import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'

/** 云算力路由 */
const CloudComputingPowerRouterView = defineComponent({
  name: 'CloudComputingPowerRouterView',
  setup() {
    return () => (
      <div>
        <RouterView />
      </div>
    )
  },
})

export default CloudComputingPowerRouterView
